import type { FC } from 'react'

import styled from '@emotion/styled'

import type { MonthlyEvents } from '@segment/api/routes/events/queries'

import EventsGrid from '../EventsGrid'
import EventDivider from '../EventDivider'

import NoResults from './NoResults'

const noUpComingEventsText = {
  heading: `We don’t have any upcoming events.`,
  description: `Try checking back or use the form below to stay informed about new events. You can also see our `,
}
const noMatchingEventsText = {
  heading: `Sorry, we couldn't find a match for that.`,
  description: `Try adjusting the filters above to expand the results. You can also see our `,
}

interface EventResultsProps {
  initialEvents: MonthlyEvents[] | undefined
  events: MonthlyEvents[] | undefined
  isLoading: boolean
}
const EventResults: FC<EventResultsProps> = ({ initialEvents, events, isLoading }) => {
  return (
    <Wrapper>
      {initialEvents?.length === 0 && (
        <NoResults heading={noUpComingEventsText.heading} description={noUpComingEventsText.description} />
      )}
      {events?.length === 0 && initialEvents?.length !== 0 && (
        <NoResults heading={noMatchingEventsText.heading} description={noMatchingEventsText.description} />
      )}
      {events?.map(({ events, monthDate }) => (
        <GridWrapper key={monthDate}>
          <EventsGrid
            events={events}
            isLoading={isLoading}
            title={new Date(`${monthDate}T00:00`).toLocaleString(`en-us`, { month: `long` })}
          />
          <EventDivider />
        </GridWrapper>
      ))}
    </Wrapper>
  )
}

const Wrapper = styled.div``
const GridWrapper = styled.div``

export default EventResults
